var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalibration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.173 1.63641V5.84421H10.1566V12.1723H10.173V16.3637H11.225V12.1723H14.3808V5.84421H11.225V1.63641H10.173ZM11.225 6.89615H13.3289V11.1204H11.225V6.89615Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0094 1.47278H11.3886V5.68057H14.5445V12.336H11.3886V16.5273H10.0094V12.336H9.99296V5.68057H10.0094V1.47278ZM10.1566 5.84421H10.173V1.63641H11.225V5.84421H14.3808V12.1723H11.225V16.3637H10.173V12.1723H10.1566V5.84421ZM13.1652 7.05979H11.3886V10.9567H13.1652V7.05979ZM11.225 6.89615V11.1204H13.3289V6.89615H11.225Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.27688 1.63641V3.73209H3.27277V14.266H3.27688V16.3637H4.32882V14.266H7.47645V3.73209H4.32882V1.63641H3.27688ZM4.32882 4.78404H6.4245V13.214H4.32882V4.78404Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.11324 1.47278H4.49246V3.56846H7.64009V14.4296H4.49246V16.5273H3.11324V14.4296H3.10913V3.56846H3.11324V1.47278ZM3.27277 3.73209H3.27688V1.63641H4.32882V3.73209H7.47645V14.266H4.32882V16.3637H3.27688V14.266H3.27277V3.73209ZM6.26087 4.94768H4.49246V13.0504H6.26087V4.94768ZM4.32882 4.78404V13.214H6.4245V4.78404H4.32882Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalibration);
export default __webpack_public_path__ + "static/media/Calibration.c22fdfcb.svg";
export { ForwardRef as ReactComponent };